import { useContext } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { UserContext } from '../../context/UserContext'

export default function AdminNav() {
  const { pathname } = useLocation()
  const { user } = useContext(UserContext)

  const tabs = [
    { name: 'Scenes', href: 'admin/scenes/allow-pages', current: !!pathname.match(/scenes/g) },
    { name: 'Users', href: 'admin/users', current: !!pathname.match(/users/g) },
  ]

  if (user.roleId === 2) tabs.push({ name: 'Companies', href: 'admin/companies', current: !!pathname.match(/companies/g) })

  const classNames = (...classes) => {
    return classes.filter(Boolean).join(' ')
  }

  return (
    <div className="flex items-center ml-2">
      <div className="sm:hidden">
        <label htmlFor="tabs" className="sr-only">
          Select a tab
        </label>
        <select
          id="tabs"
          name="tabs"
          className="block w-full border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
          defaultValue={tabs?.find((tab) => tab.current)?.name}
        >
          {tabs.map((tab) => (
            <option key={tab.name}>{tab.name}</option>
          ))}
        </select>
      </div>
      <div className="hidden sm:block">
        <nav className="flex space-x-4" aria-label="Tabs">
          {tabs.map((tab) => (
            <Link
              key={tab.name}
              to={tab.href}
              className={classNames(
                tab.current ? 'bg-indigo-100 text-indigo-700' : 'text-gray-500 hover:text-gray-700',
                'px-3 py-2 font-medium text-sm rounded-md'
              )}
              aria-current={tab.current ? 'page' : undefined}
            >
              {tab.name}
            </Link>
          ))}
        </nav>
      </div>
    </div>
  )
}
